import { render, staticRenderFns } from "./AdsBlockedNoticeModal.vue?vue&type=template&id=6be2230f&scoped=true&"
import script from "./AdsBlockedNoticeModal.vue?vue&type=script&lang=js&"
export * from "./AdsBlockedNoticeModal.vue?vue&type=script&lang=js&"
import style0 from "./AdsBlockedNoticeModal.vue?vue&type=style&index=0&id=6be2230f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be2230f",
  null
  
)

export default component.exports